import styled from "@emotion/styled";
import { Card, Divider, Table, TableCell } from "@mui/material";
import dayjs from "dayjs";
import { FC } from "react"


const MyDivider = styled(Divider)`
    margin-top: 15px;
    margin-bottom: 10px;
`

interface ViewsComponentProps {
    viewsCounts: number;
    lastViewedAt: Date | null;
}

const ViewsComponent: FC<ViewsComponentProps> = ({
    viewsCounts,
    lastViewedAt,
}) => {
    return (
        <>
            <Card sx={{ mb: 2 }}>
                {((viewsCounts && viewsCounts !== 0)) ?
                    <>
                        <Table sx={{ width: '100%' }}>
                            <TableCell align="left">
                                Wyświetlenia:
                            </TableCell>
                            <TableCell align="right">{viewsCounts}</TableCell>
                        </Table>
                        <Table sx={{ width: '100%' }}>
                            <TableCell align="left">
                                Ostatnio oglądane:
                            </TableCell>
                            <TableCell align="right">{dayjs(lastViewedAt).format('DD-MM-YYYY HH:mm')}</TableCell>
                        </Table>
                    </>
                    :
                    <></>
                }
            </Card>
            {((viewsCounts && viewsCounts !== 0) || lastViewedAt) &&
                <MyDivider />
            }
        </>
    )
}

export default ViewsComponent;